import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: [],
};

export const usersSlice = createSlice({
    name: "usersSlice",
    initialState,
    reducers: {
        storeUsers: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { storeUsers } = usersSlice.actions;

export default usersSlice.reducer;
